import instance from "./instance";
import dummyResponse from "./dummyResponse";
import { buildErrorResponse } from "../../../components/errors/httpErrorPriority";
export default class Connector {
  searchEmail = (callback) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/findpartneremail",
      method: "get",
      params: {
        programType: "APC",
      },
      headers: headers,
    };
    // callback(dummyResponse.publicDomain);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({
              isError: true,
              ...(response?.data || {}),
              httpStatus: response?.status,
            });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // const status = e.response && e.response.status;
          // e.response && e.response.data
          //     ? callback({
          //         isError: true,
          //         ...e.response.data,
          //         httpStatus: status,
          //       })
          //     : callback({ isError: true, httpStatus: status });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  createPartner = (callback, body, actionType) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/register",
      method: "post",
      params: {
        actionType: actionType,
      },
      data: body,
      headers: headers,
    };
    //callback(dummyResponse.statusCheckProgress);
    //window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (typeof callback === "function") {
            if (response?.status === 200) {
              callback(response?.data);
            } else {
              callback({ isError: true, message: response?.data?.message });
            }
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({"isError": true});
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updatePartner = (callback, accountId, body, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/register/" + accountId,
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    // window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    //callback(dummyResponse.statusCheckProgress);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true, message: response?.data?.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({"isError": true});
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  statusCheck = (callback, url) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: url,
      method: "get",
      headers: headers,
    };
    // callback(dummyResponse.statusCheckProgress);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({"isError": true});
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  upsertPrimaryAndSecondary = (
    callback,
    body_0,
    contactId_0,
    body_1,
    contactId_1 = null,
  ) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    // callback(dummyResponse.createContact,dummyResponse.updateContact)
    if (contactId_1) {
      const config_0 = {
        url: "/v1/APC/invitecontact/" + contactId_0,
        method: "put",
        data: body_0,
        headers: headers,
      };
      const config_1 = {
        url: "/v1/APC/invitecontact/" + contactId_1,
        method: "put",
        data: body_1,
        headers: headers,
      };
      Promise.all([instance.request(config_0), instance.request(config_1)])
        .then((response) => {
          if (typeof callback === "function") {
            if (response[0].status === 200 && response[1].status === 200) {
              callback(response[0].data, response[1].data);
            } else {
              if (response[0].data && response[0].data.message) {
                callback(
                  { isError: true, ...response[0].data },
                  { ...response[1].data },
                );
              } else if (response[1].data && response[1].data.message) {
                callback(
                  { ...response[0].data },
                  { isError: true, ...response[1].data },
                );
              } else {
                callback({ isError: true });
              }
            }
          }
        })
        .catch((e) => {
          if (typeof callback === "function") {
            if (e.response[0] && e.response[0].data) {
              callback(
                { isError: true, ...e.response[0].data },
                { ...e.response[1].data },
              );
            } else if (e.response[1] && e.response[1].data) {
              callback(
                { ...e.response[0].data },
                { isError: true, ...e.response[1].data },
              );
            } else {
              // callback({ isError: true });
              const error = buildErrorResponse(e);
              callback(error);
            }
          }
        });
    } else {
      const config_0 = {
        url: "/v1/APC/invitecontact/" + contactId_0,
        method: "put",
        data: body_0,
        headers: headers,
      };
      const config_1 = {
        url: "/v1/APC/invitecontact",
        method: "post",
        data: body_1,
        headers: headers,
      };
      Promise.all([instance.request(config_0), instance.request(config_1)])
        .then((response) => {
          if (typeof callback === "function") {
            if (response[0].status === 200 && response[1].status === 200) {
              callback(response[0].data, response[1].data);
            } else {
              if (response[0].data && response[0].data.message) {
                callback(
                  { isError: true, ...response[0].data },
                  { ...response[1].data },
                );
              } else if (response[1].data && response[1].data.message) {
                callback(
                  { ...response[0].data },
                  { isError: true, ...response[1].data },
                );
              } else {
                // callback({ isError: true });
                const error = buildErrorResponse(e);
                callback(error);
              }
            }
          }
        })
        .catch((e) => {
          if (typeof callback === "function") {
            if (e.response[0] && e.response[0].data) {
              callback(
                { isError: true, ...e.response[0].data },
                { ...e.response[1].data },
              );
            } else if (e.response[1] && e.response[1].data) {
              callback(
                { ...e.response[0].data },
                { isError: true, ...e.response[1].data },
              );
            } else {
              // callback({ isError: true });
              const error = buildErrorResponse(e);
              callback(error);
            }
          }
        });
    }
  };

  createContact = (callback, body) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/invitecontact",
      method: "post",
      data: body,
      headers: headers,
    };
    //window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    // callback(dummyResponse.createContact);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            // callback({ isError: true, message: response?.data?.message });
            const error = buildErrorResponse(e);
            callback(error);
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true, message: "We encountered an error" });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateContact = (callback, body, contactId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/invitecontact/" + contactId,
      method: "put",
      data: body,
      headers: headers,
    };
    // window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    //callback(dummyResponse.updateContact);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true, message: response?.data?.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  deleteContact = (callback, contactId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/invitecontact/" + contactId,
      method: "delete",
      headers: headers,
    };
    //window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    // callback();
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true, message: response?.data?.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };
  getTnC = (callback, country) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/terms",
      method: "get",
      headers: headers,
    };
    //callback({"allTerms" : TnC[country === 'US' ? 'en_US' : 'de_DE']});
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data?.terms);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };
}
